import {
  RiskThresholdLevelCode,
  RiskThresholdLevelName,
  type IAcceptanceCategory
} from 'app/services/api/acceptanceCategories'

export const riskThresholdsTemplate: {
  [idx: number]: ReadonlyArray<Readonly<IAcceptanceCategory>>
} = Object.freeze({
  3: [
    {
      code: RiskThresholdLevelCode.LowRisk,
      name: RiskThresholdLevelName.LowRisk,
      minValue: 0,
      maxValue: 1000,
      minDensityValue: 0,
      maxDensityValue: 1000,
      colour: '51AD3E',
      enabled: true,
      canBeDeleted: false
    },
    {
      code: RiskThresholdLevelCode.MediumRisk,
      name: RiskThresholdLevelName.MediumRisk,
      minValue: 1000,
      maxValue: 10000,
      minDensityValue: 1000,
      maxDensityValue: 10000,
      colour: 'EEB242',
      enabled: true,
      canBeDeleted: false
    },
    {
      code: RiskThresholdLevelCode.HighRisk,
      name: RiskThresholdLevelName.HighRisk,
      minValue: 10000,
      maxValue: 1.7976931348623157e308,
      minDensityValue: 10000,
      maxDensityValue: 1.7976931348623157e308,
      colour: 'BF3438',
      enabled: true,
      canBeDeleted: false
    }
  ],
  4: [
    {
      code: RiskThresholdLevelCode.LowRisk,
      name: RiskThresholdLevelName.LowRisk,
      minValue: 0,
      maxValue: 1000,
      minDensityValue: 0,
      maxDensityValue: 1000,
      colour: '51AD3E',
      enabled: true,
      canBeDeleted: false
    },
    {
      code: RiskThresholdLevelCode.MediumRisk,
      name: RiskThresholdLevelName.MediumRisk,
      minValue: 1000,
      maxValue: 5000,
      minDensityValue: 1000,
      maxDensityValue: 5000,
      colour: 'EEB242',
      enabled: true,
      canBeDeleted: false
    },
    {
      code: RiskThresholdLevelCode.HighRisk,
      name: RiskThresholdLevelName.HighRisk,
      minValue: 10000,
      maxValue: 1.7976931348623157e308,
      minDensityValue: 10000,
      maxDensityValue: 1.7976931348623157e308,
      colour: 'BF3438',
      enabled: true,
      canBeDeleted: false
    },
    {
      code: RiskThresholdLevelCode.MediumHighRisk,
      name: RiskThresholdLevelName.MediumHighRisk,
      minValue: 5000,
      maxValue: 10000,
      minDensityValue: 5000,
      maxDensityValue: 10000,
      colour: 'DD7139',
      enabled: true,
      canBeDeleted: true
    }
  ],
  5: [
    {
      code: RiskThresholdLevelCode.LowRisk,
      name: RiskThresholdLevelName.LowRisk,
      minValue: 0,
      maxValue: 1000,
      minDensityValue: 0,
      maxDensityValue: 1000,
      colour: '51AD3E',
      enabled: true,
      canBeDeleted: false
    },
    {
      code: RiskThresholdLevelCode.MediumRisk,
      name: RiskThresholdLevelName.MediumRisk,
      minValue: 4000,
      maxValue: 7000,
      minDensityValue: 4000,
      maxDensityValue: 7000,
      colour: 'EEB242',
      enabled: true,
      canBeDeleted: false
    },
    {
      code: RiskThresholdLevelCode.HighRisk,
      name: RiskThresholdLevelName.HighRisk,
      minValue: 10000,
      maxValue: 1.7976931348623157e308,
      minDensityValue: 10000,
      maxDensityValue: 1.7976931348623157e308,
      colour: 'BF3438',
      enabled: true,
      canBeDeleted: false
    },
    {
      code: RiskThresholdLevelCode.MediumHighRisk,
      name: RiskThresholdLevelName.MediumHighRisk,
      minValue: 7000,
      maxValue: 10000,
      minDensityValue: 7000,
      maxDensityValue: 10000,
      colour: 'DD7139',
      enabled: true,
      canBeDeleted: true
    },
    {
      code: RiskThresholdLevelCode.MediumLowRisk,
      name: RiskThresholdLevelName.MediumLowRisk,
      minValue: 1000,
      maxValue: 4000,
      minDensityValue: 1000,
      maxDensityValue: 4000,
      colour: 'C4D146',
      enabled: true,
      canBeDeleted: true
    }
  ]
})
